import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import { Theme } from "../data/style/Theme";
import { getScaling } from "../api/exercises";
import { useQuery } from "@tanstack/react-query";
import useScreenSize from "../context/ScreenContext";
import { SCALING_BENEFITS, SCALING_REASONS } from "../data/assets/arrays";
import { SCALING_CONCLUSION, SCALING_INTRO } from "../data/assets/texts";
import {
  CenteredRow,
  MainText,
  MainTitle,
  scrollBar,
  SecondaryTitle,
  AllCenteredColumn,
} from "../data/style/Style";

const Arrow = () => {
  return (
    <Box minWidth={"22px"}>
      <MainText bold={"true"}>{">>"}</MainText>
    </Box>
  );
};

const SectionCard = ({ children }) => {
  return (
    <Stack
      sx={{
        background: Theme.palette.card,
        border: 1,
        borderColor: Theme.palette.border,
        borderRadius: 3,
        padding: 1,
      }}
    >
      {children}
    </Stack>
  );
};
const Scaling = () => {
  const { size } = useScreenSize();
  var [width] = size;

  const { data, isPending } = useQuery({
    queryKey: ["exercise", "scaling"],
    queryFn: ({ signal }) => getScaling({ signal }),
  });

  return (
    <Stack height={"100%"} pl={1} pr={1}>
      <Stack sx={scrollBar} height={"100%"} overflow={"auto"}>
        <Stack direction={"row"} mt={1} flex={1} flexWrap={"wrap"} gap={2}>
          <Stack width={width < 900 ? "100%" : "48%"} gap={2}>
            <Stack
              sx={{
                background: Theme.palette.card,
                border: 1,
                borderColor: Theme.palette.orange,
                borderRadius: 3,
                padding: 1,
              }}
              gap={1}
            >
              <SecondaryTitle
                sx={{ color: Theme.palette.orange + " !important" }}
              >
                About Scaling
              </SecondaryTitle>
              <MainText>{SCALING_INTRO}</MainText>
            </Stack>
            <CenteredRow gap={1}>
              <AllCenteredColumn
                p={1}
                sx={{
                  background: Theme.palette.orange + "22",
                  border: 1,
                  borderColor: Theme.palette.orange,
                  borderRadius: 3,
                }}
              >
                🎯
              </AllCenteredColumn>
              <MainTitle>The Need for Scaling</MainTitle>
            </CenteredRow>
            {SCALING_REASONS.map((item) => (
              <SectionCard>
                <CenteredRow gap={1} mb={1}>
                  <AllCenteredColumn
                    p={1}
                    sx={{
                      background: Theme.palette.orange + "22",
                      border: 1,
                      borderColor: Theme.palette.orange,
                      borderRadius: 3,
                    }}
                  >
                    {item.icon}
                  </AllCenteredColumn>
                  <MainText>{item.title}</MainText>
                </CenteredRow>
                <MainText sx={{ color: Theme.palette.muted + " !important" }}>
                  {item.text}
                </MainText>
              </SectionCard>
            ))}
            <CenteredRow gap={1}>
              <AllCenteredColumn
                p={1}
                sx={{
                  background: Theme.palette.orange + "22",
                  border: 1,
                  borderColor: Theme.palette.orange,
                  borderRadius: 3,
                }}
              >
                ✨
              </AllCenteredColumn>
              <MainTitle>The Benefits of Scaling</MainTitle>
            </CenteredRow>
            {SCALING_BENEFITS.map((item) => (
              <SectionCard>
                <CenteredRow gap={1} mb={1}>
                  <AllCenteredColumn
                    p={1}
                    sx={{
                      background: Theme.palette.orange + "22",
                      border: 1,
                      borderColor: Theme.palette.orange,
                      borderRadius: 3,
                    }}
                  >
                    {item.icon}
                  </AllCenteredColumn>
                  <MainText>{item.title}</MainText>
                </CenteredRow>
                <MainText sx={{ color: Theme.palette.muted + " !important" }}>
                  {item.text}
                </MainText>
              </SectionCard>
            ))}

            <Stack
              sx={{
                background: Theme.palette.card,
                border: 1,
                borderColor: Theme.palette.orange,
                borderRadius: 3,
                padding: 1,
              }}
              gap={1}
            >
              <SecondaryTitle
                sx={{ color: Theme.palette.orange + " !important" }}
              >
                Conclusion
              </SecondaryTitle>
              <MainText>{SCALING_CONCLUSION}</MainText>
            </Stack>
          </Stack>
          <Stack p={1} width={width < 900 ? "100%" : "48%"} gap={2}>
            <SecondaryTitle
              sx={{ color: Theme.palette.orange + " !important" }}
            >
              Exercise Scaling
            </SecondaryTitle>
            {!isPending && (
              <Stack gap={2} width={width < 900 ? "100%" : "80%"}>
                {data.map((item) => (
                  <CenteredRow gap={width < 900 ? 0.5 : 1}>
                    <Box
                      sx={{
                        background: Theme.palette.orange + "22",
                        padding: 1,
                        border: 1,
                        borderColor: Theme.palette.orange,
                        borderRadius: 4,
                      }}
                    >
                      <MainText fontSize={"0.9rem"}>
                        {item.exercise_name}
                      </MainText>
                    </Box>
                    <Arrow />
                    <Box
                      sx={{
                        background: Theme.palette.up + "22",
                        padding: 1,
                        border: 1,
                        borderColor: Theme.palette.up,
                        borderRadius: 4,
                      }}
                    >
                      <MainText fontSize={"0.9rem"}>
                        {item.scaled_exercise}
                      </MainText>
                    </Box>
                    {item.scaled_exercise_scaling && (
                      <>
                        <Arrow />
                        <Box
                          sx={{
                            background: Theme.palette.up + "22",
                            padding: 1,
                            border: 1,
                            borderColor: Theme.palette.up,
                            borderRadius: 4,
                          }}
                        >
                          <MainText fontSize={"0.9rem"}>
                            {item.scaled_exercise_scaling.scaled_exercise}
                          </MainText>
                        </Box>
                      </>
                    )}
                  </CenteredRow>
                ))}
              </Stack>
            )}
          </Stack>
        </Stack>
      </Stack>
    </Stack>
  );
};

export default Scaling;
